import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";

export function LogoutPage() {
  const { user, signOut, signIn } = useAuth();
  const [signingOut, setSigningOut] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function ensureSignedOut() {
      if (!user || signingOut) {
        return;
      }
      setSigningOut(true);
      try {
        await signOut();
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Unable to complete sign out.");
        }
      } finally {
        if (!cancelled) {
          setSigningOut(false);
        }
      }
    }
    void ensureSignedOut();
    return () => {
      cancelled = true;
    };
  }, [user, signOut, signingOut]);

  return (
    <section className="panel" style={{ maxWidth: "540px", margin: "2rem auto" }}>
      <h2>Signed out</h2>
      <p className="helper-text">
        {signingOut
          ? "Wrapping up your session…"
          : "You have been signed out of the AWS COE Staffing Canvas."}
      </p>
      {error && <div className="alert error">{error}</div>}
      <button type="button" className="primary" onClick={() => void signIn()} style={{ marginTop: "1rem" }}>
        Sign in again
      </button>
    </section>
  );
}
